<template>
    <div class="compamy_box">
        <LoginTip :isLogin="user && user.nickname && !iframePage" :renderData="user" pageFrom="company"/>
        <div class="compamy_desc">
            <div class="content">
                <div class="flex_box justify-content_flex-justify align-items_center">
                    <div>
                        <p class="fs20 co_fff font_b company elli1">{{ company }}舆情健康指数</p>
                        <p class="co_fff8 flex_box time_box fs12" >
                            {{ general.updatedAt }}
                            <question-box class="ml5 flex_box align-items_center" msg="基于全网舆情数据，以正面及中性舆情影响力在整体舆情影响力中的占比为核心，运用人工智能分析处理技术、进行归一化运算得出舆情健康指数。"></question-box>
                        </p>
                    </div>
                    <p class="co_fff"><span class="fs42 font_b">{{ general.score }}</span><span
                        class="fs14">分</span>
                    </p>
                </div>
            </div>
            <div class="stats justify-content_flex-justify co_fff8 fs12">
                <div class="total line">
                    <span><b class="fs16 font_b">{{ general.articleCount }}</b>篇</span>
                    <p>舆情报道总量</p>
                </div>
                <div class="subject line">
                    <span><b class="fs16 font_b">{{ general.subjectArticleCount }}</b>篇</span>
                    <p>主体性报道</p>
                </div>
                <div class="negative line">
                    <span><b class="fs16 font_b">{{ general.negativeCount }}</b>篇</span>
                    <p>企业敏感报道</p>
                </div>
                <div class="manager_negative">
                    <span><b class="fs16 font_b">{{ general.managerNegativeCount }}</b>篇</span>
                    <p>高管敏感报道</p>
                </div>
            </div>
        </div>
        <div class="compamy_waring">
            <section class="flex_box">
                <div class="head">
                    <b>近期预警：{{ warning.count }}</b>
                </div>
                <p class="flex_1 text_r toMoreIcon" v-show="vipUser">
                    <img @click="$router.push({ path: '/warnings', query: { company: company } })" src="../assets/img/icon/toMoreIcon.svg" alt="去详情">
                </p>
            </section>

            <div class="cards" v-if="warning.list.length">
                <div class="card_item">
                    <swiper :options="warnSwiperOption" ref="warnCentSwiper">
                        <swiper-slide v-for="(v,k) in warning.list" :key="k">
                            <p class="content line-clamp_1">
<!--                                <span class="time">[{{ v.dateStr }}]</span>-->
                                {{ v.title }}
                            </p>
                            <div class="textBox flex_box mt6">
                                <p class="flex_1 fs10 co_B0">{{ v.lastMedia.media || v.media }} {{v.forwardCount ? "| 转载量" + v.forwardCount : ""}}</p>
                                <span class="text_r timeBox fs10 co_B0">{{ v.lastCreated | formatDateStr }}</span>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </div>
            </div>
            <div class="no_warining" v-else>
                <p>{{noWarnStr}}</p>
            </div>
        </div>
        <div class="compamy_analysis">
            <div class="nav flex_box">
                <section :id='index' v-for="(item,index) in companyNavList" :key='index'
                         :class="{ active: selected === index }" @click="checkNav(index)">
                    <p>{{ item }}</p>
                    <p class="subLine"></p>
                </section>
            </div>
            <div v-if="selected === 0">
                <section>
                    <LineChart
                        v-if="companyHealth"
                        :labelData="labelData"
                        :entity="company"
                        entityType="company"
                        :renderData="companyHealth"
                        :mainChief="companyNegChief"
                        :articleCount="general.articleCount"
                        :subjectArticleCount="general.subjectArticleCount"
                        :formatxAxisDate="isLogin"
                    />
                    <p class="chartLine"></p>
                    <ArticleCountMapChart
                        v-if="fameStats"
                        :renderData="fameStats.provinceArticle"
                        entityType="company"
                        title="舆情报道分布"/>
                    <p class="chartLine"></p>
                    <SubCompany v-if="!!subCompanies.length" :list="subCompanies" title="下属机构风险"></SubCompany>
                    <p v-if="!!subCompanies.length" class="chartLine"></p>
                    <PieChart v-if="fameStats"
                              :isEffect="true"
                              chartTitle="影响力等级"
                              entity="company"
                              chartId="PieChart"
                              :industry= "company"
                              chartShowEntityCountUnit="篇"
                              :renderData="fameStats.broadcastEffect"
                              :yesterdayData="fameStats.broadcastEffectYesterday"
                              :mainAffectEventByTendency="fameStats.mainAffectEventByTendency"
                              :effectForwardCountsByTendency = "fameStats.effectForwardCountsByTendency"/>
<!--                    <PercentBar v-if="fameStats" :renderData="fameStats.broadcastEffect" class="mb20"></PercentBar>-->
                    <EventStatsBar
                      v-if="fameStats"
                      :renderData="fameStats"
                      class="mb20"/>

                </section>
            </div>

            <div v-if="selected === 1">
                <section>
                    <BarChartCrosswise
                        title="风险概况"
                        entityType="company"
                        riskType="yinbaoRisk"
                        :renderData="riskStats.general.yinbaoRiskCounts"
                        :setContent="setRiskContent"
                        :tagNum=10 />
                    <BarChartCrosswise
                        firstTitle="主要内容风险点"
                        entityType="company"
                        chartTitle="主要内容风险点"
                        :renderData="riskStats.general.riskCategoryCountList"
                        :onlyChart="true"
                        :tagNum=10 />
                    <PieChart v-if="riskStats"
                              title="风险等级占比"
                              chartId="PieChartGeneral"
                              :onlyChart="true"
                              :isEffect="false"
                              :hasIcon="true"
                              imgClass="textIcon"
                              :riskLevelStr="riskLevelStr"
                              chartShowEntityCountUnit="件"
                              :renderData="riskStats.general.riskLevelCountList"/>
                </section>
            </div>
            <div v-if="selected === 2">
                <section>
                    <div class="box noRight">
                        <p class="title tendency">渠道报道倾向</p>
                        <div class="channel_select">
                            <span v-for="(item,index) in channelStatsButtons" :key='index' @click="changeEntity(item)"
                                  :class="activeName === item.tag ? item.tag + '_active' : ''">{{ item.name }}</span>
                        </div>
                        <TendencyChart v-if="activeName === 'company'" chart-box='company' key="companyChart"
                                       :channelStats='fameStats.channelTendency' :entity="company" entityType="company"/>
                        <TendencyChart v-if="activeName === 'manager'" chart-box='manager' key="managerChart"
                                       :channelStats='managerPart.channelTendency' :entity="company" entityType="company"/>
                    </div>
                    <p class="chartLine"></p>
                    <MediaReports
                        entityType="company"
                        :renderData='mediaStats'
                        :entity="company"
                        title="媒体报道倾向"
                        :articleCount="general.subjectArticleCount"
                    ></MediaReports>
                    <p class="chartLine"></p>
                    <div class="box" v-if="!managerPart.managerReport || !managerPart.managerReport.length">
                        <p class="title manager">高管报道</p>
                        <p>今日暂无高管相关报道!</p>
                    </div>

                    <ArticleStatsChart class="box" v-else :entity="company" :renderData="managerPart.managerReport"/>
                    <p class="chartLine"></p>
                    <ArticleList :renderData="reportTop5"
                                 title="实时报道"
                                 :selectTab=true
                                 :assignPositive="true"
                                 entity="article"
                                 @checkMore="checkMoreArticle"
                    ></ArticleList>
                </section>
            </div>

            <section v-if="selected === 3">
<!--                <GeneralCatalogue :isLogin="isLogin" :renderData="webChannelData"></GeneralCatalogue>-->
                <p class="chartLine"></p>
<!--                <WebPositiveLineChart-->
<!--                    chartId="webPositive"-->
<!--                    key="webPositive"-->
<!--                    imgClass="textIcon"-->
<!--                    :isLogin="isLogin"-->
<!--                    :labelData="['整体口碑']"-->
<!--                    :renderData="chartLineData">-->
<!--                </WebPositiveLineChart>-->
<!--                <p class="chartLine"></p>-->
<!--                <KeywordSnapShoot v-if="keywordIwomStats && isLogin" :renderData="keywordIwomStats"></KeywordSnapShoot>-->
            </section>
        </div>
        <LoadingPage :loading="loading"/>
        <Toast v-if="!isLogin" :text="toastText"/>
    </div>
</template>

<script>
import QuestionBox from "@/components/common/QuestionBox";
import TendencyChart from "@/components/chart/TendencyChart";
import MediaReports from "@/components/entity/MediaReports";
import ArticleStatsChart from "@/components/chart/ArticleStatsChart";
import LineChart from "@/components/chart/LineChart";
import ArticleCountMapChart from "@/components/chart/ArticleCountMapChart"
import SubCompany from "@/components/entity/SubCompany"
import PieChart from "@/components/chart/PieChart"
import EventStatsBar from "@/components/entity/EventStatsBar"
import ArticleList from "@/components/entity/ArticleList"
import BarChartCrosswise from "@/components/chart/BarChartCrosswise"
import req from "@/util/request.js";
import _ from "loadsh";
import _co from "@/util/const"
import moment from "moment";
import common from "@/util/common";

export default {
    name: 'Home',
    components: {
        QuestionBox,
        TendencyChart,
        MediaReports,
        ArticleStatsChart,
        LineChart,
        ArticleCountMapChart,
        SubCompany,
        PieChart,
        EventStatsBar,
        ArticleList,
        BarChartCrosswise,
        // WebPositiveLineChart(render){ require(["@/components/chart/WebPositiveLineChart"], render) },
        LoadingPage(render){ require(["@/components/common/LoadingPage"], render) },
        // KeywordSnapShoot(render){ require(["@/components/chart/ThermalChart"], render) },
        // GeneralCatalogue(render){ require(["@/components/common/GeneralCatalogue"], render) },
        // KeywordSnapShoot(render){ require(["@/components/common/KeywordSnapShoot"], render) },
        LoginTip(render){require(["@/components/common/LoginTip"], render)},
        Toast(render){require(["@/components/common/Toast"], render)},
    },
    props: {},
    watch: {},
    data() {
        return {
            msg: "myCompany",
            toastText:`<p>当前页面为“我的企业”样例示范，</p><p>注册会员后可查阅企业舆情详情。</p>`,
            warnSwiperOption: {
                speed: 300,
                autoplay: {
                    delay: 3000
                },
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass: 'swiper_bullet',
                    bulletActiveClass: 'swiper_bullet_active',
                    clickable: true,
                }
            },
            companyNavList: _co.companyNavList,
            channelStatsButtons: _co.channelStatsButtons,
            user: common.getUser(),
            company: "",
            activeName: 'company',
            selected: 0,
            loading: true,
            fameStats: null,
            riskStats: null,
            reportTop5: null,
            managerPart: null,
            mediaPart: null,
            setRiskContent: null,
            companyNegChief: null,
            general: {
                updatedAt: "",
                score: 0,
                articleCount: 0,
                subjectArticleCount: 0,
                negativeCount: 0,
                managerNegativeCount: 0
            },
            warning: {
                count: 0,
                list: []
            },
            mediaStats: [],
            companyHealth: null,
            subCompanies: [],
            managerNegativeCount: 0,

            labelData: [],
            isNoWeb: false,
            webChannelData: null,
            // chartLineData: null,
            keywordIwomStats: null,
            isLogin: false,
            riskLevelStr: "", //风险等级占比文案
            iframePage: false,
            noWarnStr: "该模块仅对会员单位开放",
            vipUser: false
        }
    },
    created() {
        this.isLogin = !!this.user;

        if(this.user && this.user.vipLevel){
            this.noWarnStr = "当前企业暂无敏感报道预警";
            this.vipUser = !!this.user.vipLevel;
        }

        // 编审管理后台 主新闻会嵌入h5, 此处参数是为了管理后台的嵌入页面可以跳过登录直接访问
        if (this.$route.query.token === _co.token || this.$route.query.source === _co.source) {
            this.isLogin = true;
            this.iframePage = true;
            this.noWarnStr = "当前企业暂无敏感报道预警";
            this.vipUser = true;
        }
    },
    mounted() {
        this.getData()
        // 编审管理后台 主新闻会嵌入h5, 此处参数是为了与编审管理后台嵌入的页面进行交互
        if(this.$route.query.addEvent) {
            window.isIframe = true;
            window.addEventListener("message", function(event){
                if(event.data.cmd === 'toReload') {
                    location.reload()
                }
                else if(event.data.cmd === 'noLoad') {
                    window.noLoad = true;
                }
                else if(event.data.cmd === 'canLoad') {
                    window.noLoad = false;
                }
            });
        }
    },
    filters: {
        formatDateStr(date, unit = "YYYY/MM/DD HH:mm") {
            return  (date && date ==="xx-xx")? date : common.formatStr(date, unit)
        }
    },
    methods: {
        async getData() {
            let resp = await req.company(this.$route.params.name, {xinhuaToken: this.iframePage ? _co.token : ""});
            if(!resp){
                return ;
            }
            let {general, companyPart, managerPart, mediaPart} = resp;
            this.general = general;
            this.company = general.name;
            //！！未登录，直接显示服务端返回数据
            this.general.updatedAt =  this.isLogin ? moment(this.general.updatedAt).format('YYYY年M月D日') : this.general.updatedAt;
            this.warning.count = _.get(general, "alert.count", 0);
            this.warning.list = _.get(general, "alert.list", []);

            let {fameStats, reportTop5, riskStats, mainChief} = companyPart;
            this.companyHealth = {
                each: _.get(fameStats, "fameHealthTrend.companyHealths", []),
                average: _.get(fameStats, "fameHealthTrend.industryHealths", [])
            }
            this.fameStats = fameStats;
            this.reportTop5 = reportTop5;
            this.companyNegChief = mainChief;
            this.riskStats = riskStats;
            this.managerPart = managerPart;
            let {mediaPartCount} = mediaPart;
            this.mediaStats = mediaPartCount;
            this.labelData = [general.name, `${common.convertEntityName(general.industry, "industry")}`];


            // 处理chart显示的事件数/文章数
            let {broadcastEffect, effectForwardCounts} = fameStats;
            if(effectForwardCounts){
                _.each(broadcastEffect, item => {
                    let info  = _.find(effectForwardCounts, {key: item.level});
                    item.articleCount = info ? info.value : 0;
                });
            }


            //风险分析
            let {yinbaoRiskCounts, riskCategoryCountList, riskLevelCountList, highRiskLevelEvents} = riskStats.general;
            let riskCount = _.sumBy(riskLevelCountList, 'count');
            this.setRiskContent = `今日，${this.company}暂无敏感事件。`;
            if(riskCount){
                this.setRiskContent = `今日，${this.company}共发生敏感事件<b>${ riskCount }件</b>`;
                this.setRiskContent += `。${common.getRiskLabelStr(yinbaoRiskCounts, riskCategoryCountList, "company")}`

            }
            this.riskLevelStr = common.getRiskLevelContent('日', this.company, riskLevelCountList, highRiskLevelEvents, "company");
            this.loading = false;
            // this.getWebData()
        },
        async getWebData() {
            let res = await req.getWebKeyword(this.company);
            this.isNoWeb = !res;
            if(res && res !== 'confirm') {
                let { keywords,  keywordIwomStats, score, yesterdayScore, firstNegativeIwom,
                    channelStats, yesterdayChannelStats, keywordStats, yesterdayKeywordStats,
                    } = res;
                this.keywordIwomStats = _.orderBy(keywordIwomStats, "avgScore");
                this.isNoWeb = keywords.length < 1;
                this.webChannelData = {
                    firstNegativeIwom,
                    channelStats,
                    yesterdayChannelStats,
                    keywordStats,
                    yesterdayKeywordStats,
                    stats: {
                        value: score,
                        keyword: keywords.length,
                        yesterdayScore: yesterdayScore
                    },
                };
                // this.chartLineData = {
                //     target0: companyTrends,
                //     target1: keywordTrends,
                //     target2: newsTrends,
                //     target3: videoTrends,
                // }
            }
            // this.loading = false;

        },
        checkNav(index) {
            if(index === 3 && this.isNoWeb) {
                this.$messagebox({
                    title: '',
                    message: '该企业暂未开通网络口碑',
                });
                return
            }
            this.selected = index;
        },
        changeEntity(item) {
            this.activeName = item.tag;
        },
        checkMoreArticle(data) {
            let tendency = data.isPositive ? '正面' :'敏感';
            this.$router.push({ path: '/articleList', query: { company: this.company, tendency } })
        }
    }
}
</script>

<style lang="scss" scoped>

.compamy_box {
    .compamy_desc {
        font-family: PingFangSC-Regular;
        height: 154px;
        width: 100%;
        //background: url("../assets/img/company/company_bg.png") no-repeat center;
        //background-size: 100%;
        background-color: #0656cd;
        .content {
            font-size: 12px;
            padding: 20px;
            .company{
                width: 240px;
            }
        }

        .stats {
            display: flex;
            text-align: center;
            //justify-content: space-around;
        }

        .stats p {
            margin-top: 2px;
            //margin-bottom: 14px;
        }

        .total {
            width: 88px;
        }

        .subject {
            width: 90.5px;
        }

        .negative {
            width: 106.5px;
        }

        .manager_negative {
            width: 88.5px;
        }
    }

    .compamy_waring {
        height: 94px;
        background: #fff;
        border-radius: 4px;
        margin: 12px;

        .head {
            height: 24px;
            width: 126px;
            background: url("../assets/img/company/warning_card.png") no-repeat center;
            background-size: 100%;

            b {
                //width: 170px;
                height: 24px;
                font-family: PingFangSC-Medium;
                font-size: 14px;
                color: #FFFFFF;
                letter-spacing: 0;
                line-height: 24px;
                font-weight: 500;
                margin-left: 35px;
            }
        }

        .cards {
            height: 70px;
            padding: 3px 12px 0px 12px;

            .card_item {
                width: 100%;
                height: 100%;
            }

            .swiper-container {
                width: 100%;
                height: 100%;
            }

            .time {
                margin-right: 4px;
            }

            .content {
                margin-top: 3px;
            }
        }

        .no_warining {
            padding: 12px;
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            letter-spacing: 0;
        }

    }

    .compamy_analysis {
        background-color: #FFFFFF;
        padding-bottom: 20px;

        .nav {
            font-size: 16px;
            height: 52px;
            line-height: 52px;

            section {
                width: 33.33%;
                text-align: center;
                position: relative;

                .subLine {
                    width: 48px;
                    height: 3px;
                    background-color: rgba(3, 57, 159, 1);
                    border-radius: 10px;
                    position: absolute;
                    bottom: 0;
                    left: calc( (100% - 47px) / 2 );
                    display: none;
                }
            }

            .active {
                color: rgba(51, 51, 51, 1);
                font-weight: bold;

                .subLine {
                    display: inline-block
                }
            }
        }


        .box {
            padding: 16px;
            height: auto;
            &.noRight { padding-right: 0; }

            .channel_select {
                float: right;
                margin-right: 16px;
                width: 80px;
                height: 24px;
                line-height: 24px;
                color: #B0B0B0;
                transform: skew(-10deg);
                background: #EDEDED;
                font-family: PingFangSC-Medium;
                display: flex;
                letter-spacing: 0;
                font-weight: 500;

                span {
                    flex: 1;
                    text-align: center;
                    font-size: 12px;
                    border-radius: 2px;
                }

                .company_active {
                    color: #fff;
                    background: #376CCF;
                }

                .manager_active {
                    color: #fff;
                    background: #376CCF;
                }

            }

            .title {
                font-size: 16px;
                color: #333333;
                font-weight: bold;
                text-indent: 20px;
                margin-bottom: 12px;
                display: inline-block;
                background-size: 18px 18px;
                background-repeat: no-repeat;
                background-position: left center;
                &.tendency{
                    background-image: url("../assets/img/icon/chartText.png");
                }
                &.manager{
                    background-image: url("../assets/img/icon/textIcon.png");
                }
            }


        }


    }

    .mint-navbar {
        .mint-tab-item.is-selected {
            //border-bottom: none !important;
            font-weight: bold;
            color: #000000;
        }

        .mint-tab-item-label {
            font-size: 32px;
        }
    }

    .swiper-container {
        width: 100%;
        height: 100%;
    }

    .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
        bottom: 5px;
    }
}

.toMoreIcon {
    padding-right: 16px;
    img {
        width: 20px;
    }
}

</style>
